/**
 * Map clip-local time × speed to preset motion progress (0…1).
 * Speed > 1 ping-pongs so motion stays lively through the whole clip.
 */
export function motionProgressWithSpeed(tOverDuration, speed) {
  const s = Number(speed) || 0;
  if (s <= 0) return 0;
  const raw = Math.max(0, Number(tOverDuration) || 0) * s;
  if (s <= 1) return Math.min(1, raw);
  const cycle = raw % 2;
  return cycle <= 1 ? cycle : 2 - cycle;
}
